import React from 'react';

const Posts=()=>{
    return ([{ id:1, titulo:'Control Remoto Tv', texto:'Universales y por marca'},
    { id:2, titulo:'Cables', texto:'Este es el texto de mi segundo articulo'} ,
    { id:3, titulo:'Fichas HDMI', texto:'Este es el texto de mi tercer articulo'} ,
    { id:4, titulo:'SOportes', texto:'Para Tv con movilida o Fijos'} 
   ])
}
export default Posts;

